import { AnalyticIdentifier } from '@common/neo.tax';
import { ReactElement } from 'react';

import { useDomainRedirect, useProvisionCurrentUser, useReportLoginFailure } from '@neo.tax/onboarding/hooks';
import { AuthType, useAnalyticId, startOAuth, SsoProvider, LocalStorageKey } from '@neo.tax/shared';
import { AuthenticationState } from '@neo.tax/shared/state';

import { StyledGoogleIcon, StyledSsoButton } from './sso-buttons.styled';

export const GoogleOAuth = ({ authType }: { authType: AuthType }): ReactElement => {
  const googleOAuthBtnId = useAnalyticId(AnalyticIdentifier.RTC_GOOGLE_OAUTH_BUTTON);
  const { getRedirectUrlForEmail } = useDomainRedirect();
  const provisionCurrentUser = useProvisionCurrentUser();
  const reportLoginFailure = useReportLoginFailure();

  const handleClick = async (): Promise<void> => {
    localStorage.setItem(LocalStorageKey.SESSION_GOOGLE_AUTH_ATTEMPT, authType);
    await startOAuth({
      ssoProvider: SsoProvider.GOOGLE,
      adapter: AuthenticationState.authenticationStateOAuthAdapter,
      enterpriseSsoProviderId: undefined,
      getSingleTenantRedirectUrl: getRedirectUrlForEmail,
      provisionCurrentUser,
      reportLoginFailure,
    });
  };

  return (
    <StyledSsoButton id={googleOAuthBtnId} onClick={handleClick} rounded="regular" size="base" variant="white">
      <StyledGoogleIcon /> Google
    </StyledSsoButton>
  );
};
